import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { AuthService, FeaturesService } from '@services';
import { ConstantsUtil } from '@utils';
import { Feature } from '@enums';
/**
 * Init service.
 *
 * @author Mikhail Siutsou
 * @class InitServiceClass
 * @category Services
 */

var InitServiceClass = /*#__PURE__*/function () {
  function InitServiceClass() {
    _classCallCheck(this, InitServiceClass);

    _defineProperty(this, "isInit", false);
  }

  _createClass(InitServiceClass, [{
    key: "init",
    value:
    /**
     * Init method.
     *
     * @author Mikhail Siutsou
     * @return {Promise<void>} app init promise.
     */
    function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var token, userId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.isInit) {
                  _context.next = 16;
                  break;
                }

                token = sessionStorage.getItem('token');
                userId = sessionStorage.getItem(ConstantsUtil.localStorage.userId) || '';

                if (!token) {
                  _context.next = 11;
                  break;
                }

                if (!FeaturesService.available(Feature.E2EE)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return AuthService.getCurrentUserE2E();

              case 7:
                _context.next = 11;
                break;

              case 9:
                _context.next = 11;
                return AuthService.getCurrentUser(userId);

              case 11:
                _context.next = 13;
                return InitServiceClass.setServiceWorkers();

              case 13:
                this.isInit = true;
                _context.next = 17;
                break;

              case 16:
                throw new Error(ConstantsUtil.errors.APP_ALREADY_INIT_ERROR);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }], [{
    key: "setServiceWorkers",
    value:
    /**
     * Set service workers.
     *
     * @author Mikhail Siutsou
     * @private
     * @static
     * @return {Promise<ServiceWorkerRegistration | undefined>} set service workers promise.
     */
    function () {
      var _setServiceWorkers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!('serviceWorker' in navigator && FeaturesService.available(Feature.ServiceWorker))) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 3;
                return navigator.serviceWorker.register('/service.worker.js');

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function setServiceWorkers() {
        return _setServiceWorkers.apply(this, arguments);
      }

      return setServiceWorkers;
    }()
  }]);

  return InitServiceClass;
}();

var InitService = new InitServiceClass();
export { InitService };